import React, { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import useApiHandling from '../../hooks/useApiHandling';

const StyledTextAreaWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const StyledTextArea = styled.textarea<{ hasBackgroundColor: boolean }>`
    width: 100%;
    height: ${({ style }) => style?.height || '100px'};
    padding: 10px;
    border: 2px solid ${({ theme }) => theme.warningMain};
    border-radius: 5px;
    resize: none;

    &:hover {
        border: 2px solid ${({ theme }) => theme.warningMain};
        background-color: ${({ hasBackgroundColor }) =>
            hasBackgroundColor ? '' : ({ theme }) => theme.baseBackgroundColor};
    }

    &:focus {
        border-color: ${({ theme }) => theme.infoLight};
        box-shadow: 0 0 5px rgba(0, 153, 255, 0.5);
    }
`;

const HoverText = styled.div<{ isVisible: boolean }>`
    position: absolute;
    left: 50%;
    bottom: 0%;
    transform: translate(-50%, 50%);
    background-color: ${({ theme }) => theme.gray3};
    color: ${({ theme }) => theme.gray11};
    font-size: 14px;
    padding: 5px;
    pointer-events: none;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transition: ${({ isVisible }) => (isVisible ? 'opacity 0.5s ease 2s' : '')};
    white-space: nowrap;
`;

interface ICommonTextAreaProps {
    id?: string;
    value: string;
    setValue: (val: string) => void;
    placeholder?: string;
    style?: {};
    hoverText?: boolean;
}

const CommonTextArea: React.FC<ICommonTextAreaProps> = ({
    id = 'common_text_area',
    value,
    setValue,
    placeholder,
    style,
    hoverText = false,
}) => {
    const intl = useIntl();
    const [isHovered, setIsHovered] = useState(false);
    const [hasTyped, setHasTyped] = useState(false);
    const { hasBackgroundColor } = useApiHandling();

    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(e.target.value);
        if (!hasTyped) {
            setHasTyped(true);
        } else if (e.target.value === '') {
            setHasTyped(false);
        }
    };

    return (
        <StyledTextAreaWrapper onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <StyledTextArea
                id={id}
                data-testid={id}
                value={value}
                onChange={handleInputChange}
                placeholder={intl.formatMessage({ id: placeholder })}
                style={style}
                className="header-bgcolor"
                hasBackgroundColor={hasBackgroundColor}
            />
            {hoverText && (
                <HoverText isVisible={isHovered && !hasTyped}>
                    <FormattedMessage id="cap.applications.modal.hoverText" />
                </HoverText>
            )}
        </StyledTextAreaWrapper>
    );
};

export default CommonTextArea;
